{
  "settings": "Настройки",
  "yourDigitalAssistant": "Ваш цифровой помощник",
  "getStarted": "Начать",
  "login": "Авторизоваться",
  "loggingIn": "Вход в систему ...",
  "darkMode": "Ночной режим",
  "clearHistory": "Oчистить историю",
  "historyCleared": "история очищена",
  "changeLanguage": "Язык",
  "termsAndConditions": "Условия и положения",
  "messagePlaceholder": "Введите свое сообщение здесь ...",
  "messagePlaceholderDisabled": "Печатание отключено ...",
  "feedbackTitle": "Напишите свой отзыв",
  "feedbackPlaceholder": "Расскажите об этом (необязательно)",
  "feedbackSend": "Отправить",
  "feedbackClose": "закрывать",
  "sessionExpired": "Ваша сессия закончилась из-за неактивности.",
  "startNewSession": "Начать новую сессию",
  "apiError": "Упс! Что-то пошло не так. Мы работаем над тем, чтобы исправить это, как только сможем.",
  "apiErrorOffline": "Вы не подключены к Интернету.",
  "tryAgain": "Попробуй еще раз",
  "startOver": "Начать сначала",
  "chatEnded": "Чат закончился.",
  "chatEndedThankYou": "Спасибо, что побеседовали с нами!",
  "closeChat": "закрывать",
  "startNewChat": "Чат снова",
  "humanTakeoverStarted": "Теперь вас переводят в службу поддержки ...",
  "humanTakeoverQueued": "Ожидание подключения к агенту",
  "humanTakeoverAnAgent": "Агент",
  "humanTakeoverAgentEntered": "вступил в разговор",
  "humanTakeoverAgentLogout": "оставил разговор",
  "humanTakeoverTransfer": "Вы переводитесь на новый агент",
  "humanTakeoverEnded": "Вы сейчас общаетесь с вашим цифровым помощником",
  "version": "Версия",
  "formIntroText": "Пожалуйста, заполните следующую форму, чтобы начать общаться с нами.",
  "formFirstName": "Имя",
  "formLastName": "Фамилия",
  "formName": "Имя",
  "formEmail": "E-mail",
  "formWrongEmail": "Пожалуйста, укажите действительный адрес электронной почты.",
  "formPhone": "Телефон",
  "formShipmentId": "Идентификатор отгрузки",
  "formQuestion": "Ваш вопрос",
  "formAccountNumber": "Номер счета (для бизнес-клиентов)",
  "formAddress": "адрес",
  "formPostcode": "почтовый индекс",
  "formCity": "город",
  "formCountry": "страна",
  "formSubmitButton": "Начать чат",
  "formEmptyFieldError": "Недопустимо быть пустым.",
  "formPhoneNumberValidationError": "Недействительный номер телефона.",
  "formInputIsBiggerThan50": "Должно быть не более 50 символов.",
  "formInputIsBiggerThan100": "Должно быть не более 100 символов.",
  "formInputIsBiggerThan2000": "Должно быть не более 2000 символов.",
  "widgetEventOnline": "Сообщение DA: пользователь снова в сети.",
  "widgetEventHidden": "Сообщение DA: Виджет скрыт.",
  "widgetEventVisible": "Сообщение DA: Виджет виден.",
  "widgetEventVisibleMinimized": "Сообщение DA: виджет виден, но свернут.",
  "widgetEventMinimized": "Сообщение DA: Виджет свернут.",
  "widgetEventMaximized": "Сообщение DA: виджет развернут.",
  "widgetEventSessionExpired": "Сообщение DA: сеанс виджета истек.",
  "widgetEventHangupHuman": "Сообщение DA: пользователь завершает сеанс захвата людей.",
  "widgetEventUserTyping": "Сообщение DA: пользователь печатает.",
  "fileTooLarge": "Вы пытаетесь прикрепить слишком большие файлы.",
  "tooManyDiles": "Вы пытаетесь прикрепить слишком много файлов.",
  "fileInvalidType": "Вы пытаетесь прикрепить файлы недопустимого типа.",
  "attachmentsDropHere": "Перетащите сюда, чтобы загрузить или",
  "attachmentsBrowse": "Просмотр файлов",
  "attachmentsExtenstionQuantity": "pdf или изображения (до 10 файлов)",
  "attachmentsSize": "до 30 МБ",
  "attachmentsFailedUploading": "Ошибка загрузки",
  "attachmentsUploading": "Загрузка ...",
  "minimizeExpandText": "Живой чат с нами прямо сейчас!",
  "popupWidgetNotificationMessage": "Вы получили новое сообщение!",
  "tabWidgetNotificationMessage": "Новое сообщение!",
  "datepickerSendButton": "Сендай"
}
